import type { EngineClient } from './EngineClient';
import { PyodideEngineClient } from './PyodideEngineClient';

export type EngineKind = 'pyodide' | 'mock';

/** `?engine=mock` selects the fixture-backed engine; anything else runs the real one. */
export function engineKindFromUrl(search: string): EngineKind {
  return new URLSearchParams(search).get('engine') === 'mock' ? 'mock' : 'pyodide';
}

export async function createEngine(kind: EngineKind): Promise<EngineClient> {
  if (kind === 'mock') {
    const { MockEngineClient } = await import('./MockEngineClient');
    return new MockEngineClient();
  }
  return new PyodideEngineClient();
}

export * from './EngineClient';
